import { compose, concat, isNil, prop } from 'ramda';
import { columnTypes } from "@qdabra/forms-shared/sharePoint";
import { coalesceArray } from "../../../utility/arrayHelpers";
import { sanitizeFieldName } from "./list.rest.helpers";

const {
    SP_TYPE_ATTACHMENTS,
    SP_TYPE_CHOICE,
    SP_TYPE_MULTI_CHOICE,
    SP_TYPE_LOOKUP,
    SP_TYPE_LOOKUP_MULTI,
    SP_TYPE_URL,
    SP_TYPE_USER,
    SP_TYPE_USER_MULTI,
} = columnTypes;

const convertAttachment = (domain) => compose(
    concat(domain),
    prop('ServerRelativeUrl'),
);

const convertUrl = (value) => {
    const { Url, Description } = value;

    return {
       url: Url,
       description: Description,
    }
};

const convertUser = ({ Title, Name }) => ({
    displayName: Title,
    accountId: Name,
});

const valueHandler = (domain) =>(item, internalName, type) => {
    const name = sanitizeFieldName(type, internalName);
    const field = item[name];

    if (isNil(field)) {
        return null;
    }

    switch (type) {
        case SP_TYPE_ATTACHMENTS:
            return field.map(convertAttachment(domain));
        case SP_TYPE_MULTI_CHOICE:
        case SP_TYPE_LOOKUP_MULTI:
            return coalesceArray(field);
        case SP_TYPE_USER:
        case SP_TYPE_USER_MULTI:
            return coalesceArray(field).map(convertUser);
        case SP_TYPE_CHOICE:
        case SP_TYPE_LOOKUP:
            return coalesceArray(field)[0];
        case SP_TYPE_URL:
            return convertUrl(field);
        default:
            return field;
    }
};


export default valueHandler;